import React from "react";
import { Form } from "react-bootstrap";

const ColorCell = ({ props }) => {
    let data = props.data;
    let colIndex = props.colIndex;
    let textValue = data[colIndex] ?? "#000";

    return <>
        <Form.Control
            type="color"
            className="indi-table-item-color-value"
            placeholder=""
            autoComplete="off"
            value={textValue}
            readOnly
        />
    </>;
};

export default ColorCell;
